/* ============================================================================
   Barnaby Bars — weekly "guess the film / story" game configs.

   Hidden page (templates/page.guess.json → sections/guessing-game.liquid),
   linked ONLY from the weekly Klaviyo email:
       /pages/story-game?name={{ first_name }}&game=<key>
     • name  — Klaviyo merge tag → "Hey NAME" (first name only)
     • game  — the key below → prompt + bars + answer

   Each config:
     type     : 'film' | 'story'  → "Name the film?" / "Name the story?"
     answer   : the correct answer (shown on the well-done popup)
     accept   : [aliases]  extra accepted guesses (the AI judge also handles fuzzy)
     hint     : (optional) shown after a wrong guess as "Hint — …". If omitted, a masked
                answer is shown (first letter of each word + dots).
     mode     : 'name' | 'date' | 'story'  → font of the top line on the bar
                (name→Dotev, date→am-tirana italic, story→Utile). Default 'name'.
                In 'story' mode with no `name`, each bar is auto-labelled
                "Chapter 1", "Chapter 2", … "Chapter 6".
     name     : (optional) name printed on EVERY bar — the big top line (e.g. 'Kate')
     flavour  : (optional) flavour printed on EVERY bar (e.g. 'Caramel')
     bars     : the six clue bars, in order. Each is EITHER
                  'a clue line'                              (string → the message)
                OR
                  { name, flavour, message }                (override per bar)

   The bars render on the real wrapper photo with the storefront fonts/geometry —
   name in am-tirana italic, flavour + message in Sackers — exactly like the
   personaliser preview.

   Add one entry per week. Keys are yours (e.g. 'week-2026-07-13').
   ========================================================================== */
window.gameConfigs = window.gameConfigs || {};

/* Personal story — every bar shares a name + flavour (matches the product render). */
window.gameConfigs['example-kate'] = {
  type: 'story',
  answer: 'The proposal',
  accept: ['proposal', 'getting engaged', 'will you marry me', 'he proposed'],
  hint: 'It ends with the biggest question of all',
  mode: 'story',      // story format → bars labelled "Chapter 1" … "Chapter 6"
  flavour: 'Caramel',
  bars: [
    "We've talked.",
    "We've debated.",
    "We've researched.",
    "We've promised.",
    'One last thing...',
    'Can we get a dog?'
  ]
};

/* Film — a flavour per bar + the clue line (no personal name on the bar). */
window.gameConfigs['example-lion-king'] = {
  type: 'film',
  answer: 'The Lion King',
  accept: ['lion king'],
  hint: 'A Disney classic out on the savannah',
  mode: 'story',      // story format → bars labelled "Chapter 1" … "Chapter 6"
  flavour: 'Caramel',
  bars: [
    'A prince is born',
    'A jealous uncle',
    'A stampede, a loss',
    'Run away, forget who you are',
    'Hakuna Matata',
    'Return to take the throne'
  ]
};
